import React from "react";
import { styled } from "@mui/material/styles";
import { CircularProgress, Table, TableBody } from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Card,
  Stack,
  Box,
  FormControlLabel,
  FormGroup,
  Tooltip,
  Chip,
  Checkbox,
  IconButton,
} from "@mui/material";
import Button from "../../../toolkit/ButtonV1";
import { useState, useEffect, useContext } from "react";
import useFetch from "../../../utils/useFetch";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import Mastercard from "../../../icons/mastercard.svg";
import VISA from "../../../icons/VISA.svg";
import AMEX from "../../../icons/AMEX.svg";
import Discovrer from "../../../icons/Discover.svg";
import PayPal from "../../../icons/PayPal.svg";

import { useNavigate } from "react-router-dom";
import axios from "../../../utils/fvAxios";
import BaseURL from "../../../utils/base-uri.json";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import Upload from "../../../icons/Upload";
import ButtonV1 from "../../../toolkit/ButtonV1";
import { QuestionnaireContext as QuestionnaireStore } from "./../../../store/questionnaire-context";
import { getOrgType } from "../../../utils/Token";
import { ToastContainer, toast } from "react-toastify";
import LoadingSpinner from "../../../toolkit/LoadingSpinner";

export default function PaymentContent({
  Secid,
  SubId,
  SectionType,
  SubSectionTypeCondition,
  PAY,
  SKIP,
  SKIP1,
  SKIP2,
  Skippedpayment,
  markSectionAsCompleted,
  vendornameDownload,
  PqStatusID,
  SectionCompleted
}) {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const { t } = useTranslation();

  const params = new URLSearchParams(window?.location?.search);
  const PQID = params?.get("pqid");
  const questionnaireStore = useContext(QuestionnaireStore);
  const [Trg, setTrg] = useState(true);

  const {
    data: resp,
    loading,
    error,
  } = useFetch(
    "/Prequalification/SectionOrSubSectionDetails?pqId=" +
    PQID +
    "&sectionId=" +
    Secid +
    "&subSectionTypeCondition=" +
    SubSectionTypeCondition +
    "&sectionType=" +
    SectionType +
    "&subSectionId=" +
    SubId +
    "&Refresh=" + Trg
  ); // TODO: remove localhost arg
  const [response, setResponse] = useState([]);
  const [pqBus, setPqBus] = useState([]);
  const [temAddFeebus, setTemAddFeebus] = useState([]);
  const [totAddFee, setTotAddFee] = useState("");
  const [annualFeeBusData, setAnnualFeeBusData] = useState(""); //My code
  const [annualPaidBusData, annualPaidBussData] = useState("");
  const [priceToPay, setPriceToPay] = useState("");
  const [annualFee, setAnnualFee] = useState("");
  const [subscriptionFee, setSubscriptionFee] = useState("");
  const [PAdditionalBus, setPaidAdditionalBus] = useState([]);
  const [checked, setChecked] = React.useState(false);
  const [checked1, setChecked1] = React.useState(false);
  const [checked2, setChecked2] = React.useState(false);
  const [checked3, setChecked3] = React.useState(false);
  const [fileContent, setFileContent] = useState({});
  const [isReceiptLoading, setIsReceiptLoading] = useState(false);
  const [isTrainingFeeReceiptLoading, setIsTrainingFeeReceiptLoading] = useState(false);
  const [Loading, setLoading] = useState(false);


  const PAID = PAdditionalBus?.map((r) =>
    r[1]?.map((r) => r.clientBusinessUnitId)
  );

  const PriceTopay = checked == true ? 0 : priceToPay;
  const AnnualFee = checked1 == true ? 0 : annualFee;
  const TotAddFee = checked2 == true ? 0 : totAddFee;
  const SubscriptionFee = checked3 == true ? 0 : subscriptionFee;

  const SkipTypq1 = checked == true ? "1" : "";
  const SkipTypq2 = checked1 == true ? "3" : "";
  const SkipTypq3 = checked2 == true ? "2" : "";
  const SkipTypq4 = checked3 == true ? "4" : "";
  const TotalAmount = subscriptionFee != null
    ? (+PriceTopay) + (+AnnualFee) + (+TotAddFee) + (+SubscriptionFee)
    : (+PriceTopay) + (+AnnualFee) + (+TotAddFee);

  useEffect(() => {
    setLoading(true);
    if (resp?.data) {
      questionnaireStore?.setCurrentPqId(PQID);
      questionnaireStore?.setCurrentSubSectionId(SubId);
      questionnaireStore?.setCurrentSectionId(Secid);
      setPqBus(resp?.data);
      setSubscriptionFee(resp?.data?.membershipFee?.toFixed(2));
      setTemAddFeebus(resp?.data?.templateAdditionalFeeBus);
      setAnnualFeeBusData(resp?.data?.annualFeeBus); //mycode
      annualPaidBussData(resp?.data?.annualPaidBus);
      setTotAddFee(resp?.data?.totalAdditionalFee?.toFixed(2));
      setPriceToPay(resp?.data?.pqPriceToPay?.toFixed(2));
      setAnnualFee(resp?.data?.totalAnnualFee?.toFixed(2));
      setPaidAdditionalBus(Object.entries(resp?.data?.paidAdditionalBus));
      setResponse(Object.entries(resp?.data?.oneFeeAndAdditionalFeeBuGroups));
      PAY(TotalAmount?.toFixed(2));
      // SKIP(resp?.data)
      setLoading(false);
    }
  }, [resp]);

  const paymentmode = {
    paymentType: "prequalification",
    templateSectionId: Secid,
    pqId: PQID,
    mode: 1,
    skipType: [SkipTypq1, SkipTypq2, SkipTypq3, SkipTypq4]?.filter((r) => r)?.join(),
    totalAmount: TotalAmount + "",
    toPay: priceToPay + "",
  };

  const DisPayment = [3, 7, 15, 27, 5, 9, 26, 13, 8, 31]

  const notdisplay = [1, 2, 4, 6, 10, 11, 14, 16, 32, 33]

  useEffect(() => {
    PAY(TotalAmount?.toFixed(2));
    paymentmode.skipType = [SkipTypq1, SkipTypq2, SkipTypq3, SkipTypq4]
      .filter((r) => r)
      .join();
    Skippedpayment(paymentmode);
  }, [TotalAmount]);

  const navigate = useNavigate();
  const PayClick = () => {
    const PayType = subscriptionFee != null && subscriptionFee != 0 ? 'prequalification,subscription' : "prequalification";
    const payment = {
      paymentType: PayType,
      templateSectionId: Secid,
      pqId: PQID,
      mode: 1,
      skipType: [SkipTypq1, SkipTypq2, SkipTypq3, SkipTypq4]?.filter((r) => r)?.join(),
      totalAmount: TotalAmount + "",
      toPay: priceToPay + "",
    };
    axios.post("Prequalification/GetPaymentURLs", payment).then((resp) => {
      const uRL = resp?.data?.data?.url;
      const token = resp?.data?.data?.token;
      const tokenid = resp?.data?.data?.tokenId;
      const Topay = resp?.data?.data?.totalAmountToPay;
      const ItemName = resp?.data?.data?.itemName;
      // const URL=(`/vendorDetails?pqid=${PQID}&sectionid=${Secid}`)
      const URL = ('/vendorDetails?pqid=' + PQID + "&sectionid=" + Secid)
      if (resp?.data?.responseMessage == "Success") {
        navigate(
          "/payment?payurl=" +
          uRL +
          "&SECURETOKEN=" +
          token +
          "&SECURETOKENID=" +
          tokenid +
          "&Item=" +
          ItemName +
          "&Topay=" +
          Topay + "&pqId=" + PQID + "&SectionId=" + Secid
        );
      } else {
        toastNotify(resp?.data?.responseMessage);
      }
    });
  };

  const SkipPqPament = () => {
    axios.post("Prequalification/SkipPqPayment", paymentmode)
      .then((resp) => {
        if (resp?.data?.responseCode == 100) {
          toastNotify(resp?.data?.data, true);
          setTrg(!Trg);
        } else {
          toastNotify(resp?.data?.responseMessage, false);
        }
      });
  }

  const handleChange = (event) => {
    SKIP(event?.target?.checked || pqBus?.pqPriceToDisplay == 0);

    setChecked(event?.target?.checked);
  };
  const handleChange1 = (event) => {
    SKIP1(event?.target?.checked);
    setChecked1(event?.target?.checked);
  };
  const handleChange2 = (event) => {
    SKIP2(event?.target?.checked || temAddFeebus == "");
    setChecked2(event?.target?.checked);
  };
  const handleChange3 = (event) => {
    // SKIP3(event?.target?.checked);
    setChecked3(event?.target?.checked);
  };
  const CompleteTheSection = () => {
    markSectionAsCompleted(true);
  };

  const handleReceiptDownload = () => {
    setIsReceiptLoading(true);
    axios
      .get(BaseURL.dashboard.GetPaymentReceipt + "?pqId=" + PQID, {
        responseType: "blob",
      })
      .then((res) => {
        setFileContent(res);
      })
      .catch((err) => {
        setIsReceiptLoading(false);
        console.error(err);
      })
      .finally(() => {
        setIsReceiptLoading(false);
      });
  };

  const handleTrainingFeeReceiptDownload = () => {
    setIsTrainingFeeReceiptLoading(true);
    axios
      .get(BaseURL.dashboard.GetTrainingFeePaymentReceipt + "?pqId=" + PQID, {
        responseType: "blob",
      })
      .then((res) => {
        setFileContent(res);
      })
      .catch((err) => {
        setIsTrainingFeeReceiptLoading(false);
        console.error(err);
      })
      .finally(() => {
        setIsTrainingFeeReceiptLoading(false);
      });
  };

  useEffect(() => {
    if (fileContent?.data) {
      if (fileContent?.data instanceof Blob) {
        setIsReceiptLoading(false);
        setIsTrainingFeeReceiptLoading(false);

        const file = new Blob([fileContent?.data], { type: "application/pdf" });
        const fileURL = URL?.createObjectURL(file);
        const pdfWindow = window?.open();
        pdfWindow.document.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');


        // const blob = fileContent.data;
        // const blobUrl = URL.createObjectURL(blob);

        // const downloadLink = document.createElement("a");
        // downloadLink.href = blobUrl;

        // downloadLink.download = 'Payment Receipt_' + vendornameDownload;
        // downloadLink.target = "_blank"; // Open in a new tab
        // downloadLink.click();
        // URL.revokeObjectURL(blobUrl);
      } else {
        console.error("Unexpected response format");
      }
    }
  }, [fileContent]);


  return (
    <>
      {Loading ?
        <LoadingSpinner />
        :
        <Box sx={{ backgroundColor: "#fff" }}>
          <ToastContainer />
          {/* start */}
          <div
            // hidden={
            //   pqBus?.isVendorPaidMembershipFee === true ||
            //   (pqBus?.isVendorPaidMembershipFee === false && (
            //     SectionCompleted === true ||
            //     pqBus?.membershipFee == null ||
            //     pqBus?.membershipFee == 0 ||
            //     (pqBus?.membershipFee != null && SectionCompleted === true)
            //   ))
            // }
            hidden={
              pqBus?.isVendorPaidMembershipFee === true ||
              pqBus?.membershipFee == null ||
              pqBus?.membershipFee == 0
            }
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "27px",
                paddingRight: "20px",
                marginBottom: "3px"
              }}
            >
              <h5 style={{ marginRight: "auto", color: "#101828", fontWeight: 500, marginTop: "20px" }} >
                {t("Payment.label11")}
              </h5>
              <h6 style={{ color: "#101828" }} hidden={pqBus?.membershipFee == null}>
                ${pqBus?.membershipFee?.toFixed(2)}
              </h6>
            </Box>
            <Box
              hidden={getOrgType() == "Vendor"}
              sx={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "33px",
                paddingRight: "20px",
                marginBottom: 2,
                marginTop: 2,
              }}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked3}
                      onChange={handleChange3}
                    />
                  }
                  label={"Skip online payment and mark as paid for subscription fee"}
                />
              </FormGroup>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "27px",
                paddingRight: "20px",
                marginTop: 2,
              }}
            >
              <h6>
                {t("Payment.labelText1")}
              </h6>
            </Box>
            <Box sx={{ paddingRight: "10px", paddingLeft: "10px" }}>
              <Card
                sx={{
                  margin: "auto",
                  backgroundColor: "#F2F4F7",
                  padding: 2,
                  marginTop: 2,
                }}
              >
                <span style={{ color: "#667085", marginRight: "auto" }}>
                  {t("Payment.label4")}
                </span>
                <span style={{ float: "right" }}>${SubscriptionFee}</span>
              </Card>
            </Box>
          </div>
          {/*Ends  */}

          {/* start */}
          <div style={{ display: pqBus?.templateAdditionalFeeBus?.length > 0 ? "none" : "block" }}> {/*  pqBus.pqPriceToDisplay == 0 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "27px",
                paddingRight: "20px",
              }}
            >
              <h5 style={{ marginRight: "auto", color: "#101828", fontWeight: 500, marginTop: "15px" }}>
                {t("Payment.label1")} <span hidden={!pqBus?.pqBus?.length > 0}>({pqBus?.pqBus?.map((r) => r)?.join(', ')})</span>
              </h5>
              <h6 style={{ color: "#101828" }}>
                ${pqBus?.pqPriceToDisplay?.toFixed(2)}
                {pqBus?.pqPriceToDisplay == 0 && pqBus?.paymentSkipped == false && pqBus?.paymentReceived == true ? " (Fee Cap Reached) " : pqBus?.paymentReceived == true ? " (Paid) " : ""}
              </h6>
            </Box>
            <Box
              hidden={getOrgType() == "Vendor"}
              sx={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "33px",
                paddingRight: "20px",
                marginTop: 2,
              }}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        checked || pqBus?.paymentReceived == true ? true : false
                      }
                      onChange={handleChange}
                      disabled={pqBus?.paymentReceived == true}
                    />
                  }
                  label={t("Payment.labelCheckedbox")}
                />
              </FormGroup>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "27px",
                paddingRight: "20px",
                marginTop: 2,
              }}
            >
              <h6>
                {t("Payment.labelText")}: $ {pqBus?.pqPriceToDisplay?.toFixed(2)}
              </h6>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "27px",
                paddingRight: "20px",
                marginTop: 2,
              }}
            >
              <Stack direction="row" spacing={1}>
                {response?.map((r) => (
                  <>
                    {r[1]?.map((r) => (
                      <>
                        {r?.clientTemplatesForBu.map((r) => (
                          <Chip
                            sx={{
                              borderRadius: "3px",
                              backgroundColor: " #2A93DB",
                              color: "#FFFFFF",
                            }}
                            label={r?.businessUnitName}
                          />
                        ))}
                      </>
                    ))}
                  </>
                ))}
              </Stack>
            </Box>
            <Box sx={{ paddingRight: "10px", paddingLeft: "10px" }}>
              <Card
                sx={{
                  margin: "auto",
                  backgroundColor: "#F2F4F7",
                  padding: 2,
                  marginTop: 2,
                }}
              >
                <span style={{ color: "#667085", marginRight: "auto" }}>
                  {" "}
                  {t("Payment.label4")}
                </span>
                <span style={{ float: "right" }}>${PriceTopay}</span>
              </Card>
              {pqBus?.hasPayFlowReceipt && (
                <Box className="mt-3">
                  <ButtonV1
                    className="border-0"
                    role="tertiary"
                    variant="outlined"
                    id="menu_btn"
                    style={{
                      marginRight: "10px",
                      color: "var(--blue50)",
                    }}
                    trailingComponent={
                      isReceiptLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <Upload stroke="var(--blue50)" />
                      )
                    }
                    label="Download Receipt"
                    onClick={handleReceiptDownload}
                  />
                </Box>
              )}

              <hr sx={{ color: "#F2F4F7" }} />
            </Box>
          </div>
          {/*Ends  */}

          {/* start */}
          <div
            style={{
              display:
                Object.keys(annualFeeBusData)?.length === 0 ? "none" : "block",
            }}
          >
            <h5 className="mx-3" style={{ marginRight: "auto", color: "#101828", fontWeight: 500, marginTop: "15px" }}>
              Training Fee
            </h5>
            {/* <p className="mx-3">Training Fee </p> */}
            <Box
              hidden={getOrgType() == "Vendor"}
              sx={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "27px",
                paddingRight: "20px",
                marginTop: 2,
              }}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        checked1 || annualFee == 0 ? true : false
                      }
                      onChange={handleChange1}
                      disabled={annualFee == 0 ? true : false}
                      size="small"
                    />
                  }
                  label={"Skip online payment and mark as paid for annual fee"}
                />
              </FormGroup>
            </Box>
            <Box sx={{ paddingRight: "10px", paddingLeft: "10px" }}>
              <TableContainer component={Paper} className="mt-3">
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ width: "90%", color: "#667085" }}>List of BUs</TableCell>
                      <TableCell align="right" sx={{ color: "#667085", }}>Amount ($)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.entries(annualFeeBusData)?.map(([groupId, entries]) => (
                      <React.Fragment key={groupId}>
                        {entries?.map((entry, index) => (
                          <TableRow
                            key={index}
                            sx={{ "&:last-child td": { border: 0 } }}
                          >
                            <TableCell>{entry?.businessUnitName}</TableCell>
                            <TableCell align="right">
                              {/* ${entry?.annualFeeReceivedAmount?.toFixed(2)}{" "} */}
                              ${entry?.groupPrice?.toFixed(2)}{" "}

                              {PAID?.some(subArray => subArray?.includes(entry?.clientBusinessUnitId)) ? "(Paid)" : ""}
                            </TableCell>
                          </TableRow>
                        ))}
                      </React.Fragment>
                    ))}
                  </TableBody>
                  {/* <TableRow
                sx={{
                  "&:last-child td": {
                    border: 0,
                  },
                }}
              >
                <StyledTableCell> To Pay</StyledTableCell>
                <StyledTableCell align="right" sx={{ backgroundColor: "#F2F4F7" }}>
                  ${AnnualFee}
                </StyledTableCell>
              </TableRow> */}
                </Table>
              </TableContainer>
            </Box>
            <Box sx={{ paddingRight: "10px", paddingLeft: "10px" }}>
              <Card
                sx={{
                  margin: "auto",
                  backgroundColor: "#F2F4F7",
                  padding: 2,
                  marginTop: 2,
                }}
              >
                <span style={{ color: "#667085", marginRight: "auto" }}>
                  {t("Payment.label4")}
                </span>
                <span style={{ float: "right" }}>${AnnualFee}</span>
              </Card>
            </Box>
          </div>

          <div
            style={{
              display:
                Object.keys(annualPaidBusData)?.length === 0 ? "none" : "block",
            }}
          >
            <h5 className="mx-3" style={{ marginRight: "auto", color: "#101828", fontWeight: 500, marginTop: "15px" }}>
              Training Fee
            </h5>
            {/* <p className="mx-3">Training Fee</p> */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "27px",
                paddingRight: "20px",
                marginTop: 2,
              }}
            >
              <FormGroup>
                <FormControlLabel
                  hidden={getOrgType() == "Vendor"}
                  control={
                    <Checkbox
                      checked={
                        checked1 || annualFee == 0 ? true : false
                      }
                      onChange={handleChange1}
                      disabled={annualFee == 0 ? true : false}
                      size="small"
                    />
                  }
                  label={"Skip online payment and mark as paid for annual fee"}
                />
              </FormGroup>
            </Box>
            <Box sx={{ paddingRight: "10px", paddingLeft: "10px" }}>
              <TableContainer component={Paper} className="mt-3">
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ width: "90%", color: "#667085" }}>List of BUs</TableCell>
                      <TableCell align="right" sx={{ color: "#667085" }}>Amount ($)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.entries(annualPaidBusData)?.map(([groupId, entries]) => (
                      <React.Fragment key={groupId}>
                        {entries?.map((entry, index) => (
                          <TableRow
                            key={index}
                            sx={{ "&:last-child td": { border: 0 } }}
                          >
                            <TableCell>{entry?.businessUnitName}</TableCell>
                            <TableCell align="right">
                              ${entry?.annualFeeReceivedAmount?.toFixed(2)}{" "}
                              {PAID?.some(subArray => subArray?.includes(entry?.clientBusinessUnitId)) ? "(Paid)" : ""}
                            </TableCell>
                          </TableRow>
                        ))}
                      </React.Fragment>
                    ))}
                  </TableBody>
                  {/* <TableRow
                sx={{
                  "&:last-child td": {
                    border: 0,
                  },
                }}
              >
                <StyledTableCell> To Pay</StyledTableCell>
                <StyledTableCell align="right" sx={{ backgroundColor: "#F2F4F7" }}>
                  ${AnnualFee}
                </StyledTableCell>
              </TableRow> */}
                </Table>
              </TableContainer>
            </Box>
            <Box sx={{ paddingRight: "10px", paddingLeft: "10px" }}>
              <Card
                sx={{
                  margin: "auto",
                  backgroundColor: "#F2F4F7",
                  padding: 2,
                  marginTop: 2,
                }}
              >
                <span style={{ color: "#667085", marginRight: "auto" }}>
                  {t("Payment.label4")}
                </span>
                <span style={{ float: "right" }}>${AnnualFee}</span>
              </Card>
            </Box>

            {Object.keys(annualPaidBusData)?.some((key) =>
              annualPaidBusData[key]?.some(
                (item) => item.annualFeeReceivedAmount > 0
              )
            ) && (
                <Box className="mt-3 mx-2">
                  <ButtonV1
                    className="border-0"
                    role="tertiary"
                    variant="outlined"
                    id="menu_btn"
                    style={{
                      marginRight: "10px",
                      color: "var(--blue50)",
                    }}
                    trailingComponent={
                      isTrainingFeeReceiptLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <Upload stroke="var(--blue50)" />
                      )
                    }
                    label="Download Training Fee Receipt"
                    onClick={handleTrainingFeeReceiptDownload}
                  />
                </Box>
              )}
            <hr sx={{ color: "#F2F4F7" }} />
          </div>
          {/*Ends  */}

          {/* temAddFeebus */}
          <div style={{ display: temAddFeebus == "" ? "none" : "block" }}>
            <h5 className="mx-3 mt-3" style={{ marginRight: "auto", color: "#101828", fontWeight: 500, marginTop: "15px" }}>
              Additional Payment
            </h5>
            {/* <p className="mx-3">Additional Payment</p> */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "27px",
                paddingRight: "20px",
                marginTop: 2,
              }}
            >
              <FormGroup>
                <FormControlLabel
                  hidden={getOrgType() == "Vendor"}
                  control={
                    <Checkbox
                      checked={checked2 || totAddFee == 0 ? true : false}
                      onChange={handleChange2}
                      disabled={totAddFee == 0 ? true : false}
                      size="small"
                    />
                  }
                  label={"Skip online payment and mark as paid for business units"}
                //label={"Skip online payment and mark as paid for annual fee"}
                //label={t("Payment.labelCheckedbox1")}
                />
              </FormGroup>
            </Box>
            <Box></Box>
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell sx={{ width: "90%" }}>
                    List of BUs
                  </StyledTableCell>
                  <StyledTableCell align="right">Amount ($)</StyledTableCell>
                </TableRow>
              </TableHead>
              {temAddFeebus?.map((r) => (
                <TableRow sx={{ "&:last-child td": { border: 0 } }}>
                  <StyledTableCell>
                    {r?.clientName} - {r?.businessUnitName}
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    ${r?.groupPrice?.toFixed(2)} {PAID?.some(subArray => subArray.includes(r?.clientBusinessUnitId)) ? "(Paid)" : ""}
                  </StyledTableCell>
                </TableRow>
              ))}
              {/* <TableRow
                sx={{
                  "&:last-child td": {
                    border: 0,
                  },
                }}
              >
                <StyledTableCell sx={{ backgroundColor: "#F2F4F7" }}> To Pay</StyledTableCell>
                <StyledTableCell align="right" sx={{ backgroundColor: "#F2F4F7" }}>
                  ${TotAddFee}
                </StyledTableCell>
              </TableRow> */}
            </Table>
            <hr sx={{ color: "#F2F4F7" }} />
            <Box sx={{ paddingRight: "10px", paddingLeft: "10px" }}>
              <Card
                sx={{
                  margin: "auto",
                  backgroundColor: "#F2F4F7",
                  padding: 2,
                  marginTop: 2,
                }}
              >
                <span style={{ color: "#667085", marginRight: "auto" }}>
                  {t("Payment.label4")}
                </span>
                <span style={{ float: "right" }}>${TotAddFee}</span>
              </Card>
            </Box>

            {pqBus?.hasPayFlowReceipt && (
              <Box className="mt-3">
                <ButtonV1
                  className="border-0"
                  role="tertiary"
                  variant="outlined"
                  id="menu_btn"
                  style={{
                    marginRight: "10px",
                    color: "var(--blue50)",
                  }}
                  trailingComponent={
                    isReceiptLoading ? (
                      <CircularProgress size={20} />
                    ) : (
                      <Upload stroke="var(--blue50)" />
                    )
                  }
                  label={t("Payment.label7")}
                  onClick={handleReceiptDownload}
                />
              </Box>
            )}
          </div>
          {/* ends */}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "20px",
              paddingRight: "20px",
              marginTop: 2,
            }}
          >
            <a style={{ color: "#2A93DB", fontSize: "14px" }}>
              {/* {t("Payment.label7")} */}
            </a>
          </Box>
          <Box sx={{ paddingLeft: "10px", paddingRight: "10px" }}>
            <Card
              sx={{
                margin: "auto",
                backgroundColor: "#F2F4F7",
                padding: 2,
                marginTop: 2,
              }}
            >
              <span style={{ marginRight: "auto" }}> {t("Payment.label6")}</span>
              <span style={{ float: "right" }}>${TotalAmount?.toFixed(2)}</span>
            </Card>
          </Box>
          <Box className="d-flex justify-content-between mt-5">
            <Box>
              <p style={{ marginLeft: "20px", fontWeight: "bold" }}>
                {t("Payment.MainText2")}
              </p>
              <Box className="mx-3">
                <img src={Mastercard} alt="Mastercard" />
                &nbsp;
                <img src={VISA} alt="VISA" />
                &nbsp;
                <img src={AMEX} alt="AMEX" />
                &nbsp;
                <img src={Discovrer} alt="Discovrer" />
              </Box>
            </Box>
            <Box className="d-flex align-items-center">
              <p style={{ fontStyle: "italic", color: "#6c757d", maxWidth: "200px", margin: "0" }}>Online Payments are processed securely by</p>
              <img src={PayPal} alt="PayPal" />
            </Box>
          </Box>

          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
            <span>&nbsp;</span>
            <Button
              role="primary"
              label="Save"
              variant="contained"
              sx={{
                padding: "10px",
                marginTop: "20px",
                textTransform: "capitalize"
              }}
              onClick={SkipPqPament}
              hidden={((!DisPayment?.includes(PqStatusID) || TotalAmount == 0) || (checked === false && checked1 === false && checked2 === false))}
            />
            <Button
              role="primary"
              label="Pay now"
              variant="contained"
              sx={{
                padding: "10px",
                alignItems: "center",
                float: "right",
                marginTop: "20px",
              }}
              hidden={TotalAmount == 0 || !DisPayment?.includes(PqStatusID)}
              onClick={PayClick}
            />

            <Button
              role="primary"
              label="Complete & Continue "
              variant="contained"
              sx={{
                padding: "10px",
                alignItems: "center",
                float: "right",
                marginTop: "20px",
                textTransform: "capitalize"
              }}
              hidden={TotalAmount != 0 || !resp?.data || !DisPayment?.includes(PqStatusID)}
              onClick={CompleteTheSection}
            />

            <Button
              role="primary"
              label="Continue "
              variant="contained"
              sx={{
                padding: "10px",
                alignItems: "center",
                float: "right",
                marginTop: "20px",
                textTransform: "capitalize"
              }}
              hidden={TotalAmount == 0 && !DisPayment?.includes(PqStatusID) || !resp?.data || TotalAmount != 0 || DisPayment?.includes(PqStatusID)}
              onClick={CompleteTheSection}
            />
          </div>
        </Box >
      }
    </>
  );
}
